
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zwei Tage nach Ihrer Infektion – also am `}<strong parentName="p">{`Mittwoch`}</strong>{` – werden Sie selbst
ansteckend. `}<strong parentName="p">{`Ihnen geht es gut`}</strong>{`, erste Krankheits­symptome werden, wenn
überhaupt, erst in 2 bis 3 Tagen auftreten. `}<strong parentName="p">{`Die anderen Bewohner Ihres
Haushalts haben Sie bereits angesteckt`}</strong>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;